import React from "react";
import { isSteward } from "../../common/checkClient";
import DateUtil from "../../common/dateUtil";
import DataRenderer from "../../common/dataRenderer";
import StatusComp from "../../common/StatusComp";
import CommentComp from "../common/CommentComp";
import * as Survey from "survey-react";
import SurveyJsComp from "../common/SurveyJsComp";

const PreTradeDetail = (props) => {
    
    return (

        <div className="panel-body">
            <div className="panel-columns">


                {props.data.securityType !== "PrivateInvestment" ?

                    <>
                        <div className="panel-column">

                            {props.data.status &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Approval Status :</div>
                                    <div className="panel-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                                </div>
                            }

                            <div className="panel-item">
                                <div className="panel-item-label">Security Type :</div>
                                <div className="panel-item-value">{props.data.securityType}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Financial Institution :</div>
                                <div className="panel-item-value">{props.data.finInstitute}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Account Number :</div>
                                <div className="panel-item-value">{props.data.accountNumber}</div>
                            </div>

                            {props.data.securityType === 'Bond' &&
                                <div className="panel-item">
                                    <div className="panel-item-label">CUSIP :</div>
                                    <div className="panel-item-value">{props.data.cusip}</div>
                                </div>
                            }

                            <div className="panel-item">
                                <div className="panel-item-label">Security Symbol :</div>
                                <div className="panel-item-value">{props.data.securitySymbol}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Security Description :</div>
                                <div className="panel-item-value">{props.data.securityDesc}</div>
                            </div>

                        </div>

                        <div className="panel-column">

                            {props.data.createdTimeStampUserTz &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Request Created :</div>
                                    <div className="panel-item-value">
                                        {props.data.createdTimeStampUserTz}
                                    </div>
                                </div>
                            }
                            <div className="panel-item">
                                <div className="panel-item-label">Trade Action :</div>
                                <div className="panel-item-value">
                                    {DataRenderer.renderTradeAction(props.data.tradeAction)}
                                </div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Intended Trade Date :</div>
                                <div className="panel-item-value">
                                    {props.mode === "DETAIL" ? props.data.tradeDate : (props.data.tradeDate ? DateUtil.toStrDate(props.data.tradeDate):"")}
                                </div>
                            </div>

                            {!((props.data.securityType === "MutualFund" && props.data.tradeAction === 'B') || props.data.securityType === "Alternative") &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Quantity :</div>
                                    <div className="panel-item-value">{props.data.quantity}</div>
                                </div>
                            }

                            {((props.data.securityType === "Equity") || (props.data.securityType === "Bond") || (props.data.securityType === "Option") || ((props.data.securityType === "MutualFund" || props.data.securityType === "Alternative") && props.data.tradeAction === "B")) &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Dollar Amount :</div>
                                    <div className="panel-item-value">{props.data.dollarAmount}</div>
                                </div>
                            }

                            {(props.data.securityType === "Equity" || props.data.securityType === "Bond") &&
                                <>
                                    <div className="panel-item">
                                        <div className="panel-item-label">Order Type :</div>
                                        <div className="panel-item-value">{props.data.orderType}</div>
                                    </div>
                                    <div className="panel-item">
                                        <div className="panel-item-label">Limit or Stop :</div>
                                        <div className="panel-item-value">{props.data.limitStop}</div>
                                    </div>
                                    <div className="panel-item">
                                        <div className="panel-item-label">Time in Force :</div>
                                        <div className="panel-item-value">{props.data.timeForce}</div>
                                    </div>
                                </>
                            }


                            {props.data.securityType === "Alternative" && props.data.tradeAction === 'B' &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Initial/Existing :</div>
                                    <div className="panel-item-value">{props.data.investState}</div>
                                </div>
                            }

                            {props.data.securityType === "Alternative" && props.data.tradeAction === 'S' &&

                                <div className="panel-item">
                                    <div className="panel-item-label">Liquidatoin Dollar Amount :</div>
                                    <div className="panel-item-value">{props.data.liquidationAmount}</div>
                                </div>
                            }

                            {props.data.securityType === "Option" &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Covered/Uncovered :</div>
                                    <div className="panel-item-value">{props.data.optionRestriction}</div>
                                </div>
                            }

                        </div>
                    </>
                    :
                    <div className="panel-column">
                        <div className="panel-item">
                            <div className="panel-item-label">Security Type :</div>
                            <div className="panel-item-value">{props.data.securityType}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Name of the Private Investment :</div>
                            <div className="panel-item-value">{props.data.businessName}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Description of the business (what services or product it provides or produces, how will it structured, it's location etc.) :</div>
                            <div className="panel-item-value">{props.data.businessDesc}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Amount to be invested :</div>
                            <div className="panel-item-value">{props.data.dollarAmount}</div>
                        </div>
                        {isSteward() &&
                            <div className="panel-item">
                                <div className="panel-item-label">What is the number of unit/shares that you own or will own? :</div>
                                <div className="panel-item-value">{props.data.ownershipShares}</div>
                            </div>
                        }
                        {isSteward() && props.data.ownershipShares &&
                            <div className="panel-item">
                                <div className="panel-item-label">Does this make you a 25% or greater holder of the company? :</div>
                                <div className="panel-item-value">{props.data.isOwnershipBeneficial ? props.data.isOwnershipBeneficial : "No"}</div>
                            </div>
                        }
                        {!isSteward() &&
                            <div className="panel-item">
                                <div className="panel-item-label">What will be your percentage ownership in the business? :</div>
                                <div className="panel-item-value">{props.data.ownershipPercent}</div>
                            </div>
                        }
                        <div className="panel-item">
                            <div className="panel-item-label">Intended Purchase Date :</div>
                            <div className="panel-item-value">{props.mode === "DETAIL" ? props.data.tradeDate : DateUtil.toStrDate(props.data.tradeDate)}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Are you a passive investor :</div>
                            <div className="panel-item-value">{props.data.isPassiveInvestor ? props.data.isPassiveInvestor : "No"}</div>
                        </div>

                        {props.data.isPassiveInvestor === 'Yes' &&
                            <div className="panel-item">
                                <div className="panel-item-label">Please describe your involvement as a passive investor :</div>
                                <div className="panel-item-value">{props.data.passiveInvolvement}</div>
                            </div>
                        }
                        <div className="panel-item">
                            <div className="panel-item-label">Are any of your current clients, or any other individuals associated with you involved in this business opportunity? :</div>
                            <div className="panel-item-value">{props.data.isClientInvolve ? props.data.isClientInvolve : "No"}</div>
                        </div>
                        {props.data.isClientInvolve === 'Yes' &&
                            <div className="panel-item">
                                <div className="panel-item-label">If yes, please describe your associations :</div>
                                <div className="panel-item-value">{props.data.clientInvolvement}</div>
                            </div>
                        }
                        <div className="panel-item">
                            <div className="panel-item-label">How did you become aware of this business opportunity :</div>
                            <div className="panel-item-value">{props.data.businessKnowledgeSource}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Is the business publicly traded? :</div>
                            <div className="panel-item-value">{props.data.isPublicBusiness ? props.data.isPublicBusiness : "No"}</div>
                        </div>
                        {props.data.isPublicBusiness === 'Yes' &&
                            <div className="panel-item">
                                <div className="panel-item-label">If yes, please list information about the publicly traded entity :</div>
                                <div className="panel-item-value">{props.data.publicTradeEntity}</div>
                            </div>
                        }
                        {!isSteward() &&
                            <div className="panel-item">
                                <div className="panel-item-label">Did you or do you anticipate raising capital or assisting in raising capital for this business? :</div>
                                <div className="panel-item-value">{props.data.isCapitalRaise ? props.data.isCapitalRaise : "No"}</div>
                            </div>
                        }
                        {props.data.isCapitalRaise === 'Yes' &&
                            <div className="panel-item">
                                <div className="panel-item-label">If yes, please describe :</div>
                                <div className="panel-item-value">{props.data.capitalRaiseDesc}</div>
                            </div>
                        }
                        {!isSteward() &&
                            <div className="panel-item">
                                <div className="panel-item-label">How will you (or any related parties) be compensated (either direct or indirectly)? :</div>
                                <div className="panel-item-value">{props.data.compensationMethod}</div>
                            </div>
                        }
                        <div className="panel-item">
                            <div className="panel-item-label">Where will the investment or its assets be custodied? :</div>
                            <div className="panel-item-value">{props.data.custodiedInvestment}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Do you have custody or control over the funds for this business? (e.g., trustee powers, check writing authority/check signing authority, treasurer position, etc.) :</div>
                            <div className="panel-item-value">{props.data.isBusinessCustody ? props.data.isBusinessCustody : "No"}</div>
                        </div>
                        {props.data.isBusinessCustody === 'Yes' &&
                            <div className="panel-item">
                                <div className="panel-item-label">If yes, what is your role or responsibility :</div>
                                <div className="panel-item-value">{props.data.businessCustody}</div>
                            </div>
                        }
                        {props.data.attachment && 
                            <div className="panel-item">
                                <div className="panel-item-label">Attachment Document :</div>
                                <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                            </div>
                        }
                    </div>
                }

            </div>
            <CommentComp data={props.data.comments} />
        </div>
    );

}


export default PreTradeDetail;